import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import ScrollDown from '@/components/ScrollDown'
import RevealFadeIn from '@/components/RevealFadeIn'
import BigParagraph from '@/components/BigParagraph'
import { removeParagraph } from '@/utils/strings'
import useScrollStore from '@/store/scroll'
import style from './style'

const useStyles = createUseStyles(style)

const Hero = ({
  text,
  visible,
  children,
}) => {
  const { lenis } = useScrollStore()
  const classes = useStyles()

  const handleClickScrollDown = () => {
    lenis.scrollTo(window.innerHeight)
  }

  return (
    <div className={classes.root}>
      <RevealFadeIn
        visible={visible}
        className={classes.hero}
      >
        <BigParagraph
          text={removeParagraph(text)}
        />
        {children}
      </RevealFadeIn>
      <ScrollDown
        onClick={handleClickScrollDown}
        className={classNames({
          [classes.scrollDown]: true,
        })}
      />
    </div>
  )
}

export default Hero
